import {api} from "./api";
import {MODERATOR_HELP} from "../mock/URLs";
import {ISosItem} from "../types/sos";

export const getSosRequest = async ({params}) => {
  try {
    const {data} = await api.get(MODERATOR_HELP, {
      params
    })
    return data
  } catch (e) {
    throw e
  }
}

type GetSosByIdProps = {
  params?: {
    page_size?: number
  }
}
export const getSosRequestById = async (id:number, {params}: GetSosByIdProps) => {
  try {
    const {data} = await api.get<{ data: ISosItem }>(`${MODERATOR_HELP}${id}/`, {
      params
    })
    return data.data
  } catch (e) {
    throw e
  }
}
